//Add User
export const ADD_USER ="ADD_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"
export const USERS_LOADING ="USERS_LOADING"